import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CATEGORIES } from "@/constants/data";
import { BrandLogo } from "@/components/BrandLogo";

const Footer = () => {
  return (
    <footer className="border-t border-[color:var(--line)] bg-[color:hsl(var(--secondary))] mt-auto">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <BrandLogo asLink={false} iconClassName="h-12 w-auto" nameClassName="text-xl" taglineClassName="text-[10px]" className="mb-4" />
          <p className="text-sm text-[color:hsl(var(--muted-foreground))] max-w-sm leading-relaxed">
            Abdullah Karslı Gayrimenkul Danışmanlığı, mülk sahipleri ve yatırımcılar için güvenilir ve sonuç odaklı
            danışmanlık hizmeti sunar.
          </p>
        </div>
        <div>
          <h4 className="font-[var(--font-serif)] text-base mb-4 text-[color:var(--brand-charcoal)]">Kategoriler</h4>
          <ul className="space-y-2.5">
            {CATEGORIES.map((c) => (
              <li key={c.value}>
                <Link to={`/kategori/${c.value}`} className="text-sm text-[color:hsl(var(--muted-foreground))] hover:text-[color:var(--brand-charcoal)] transition-colors">
                  {c.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/hakkimizda" className="text-sm text-[color:hsl(var(--muted-foreground))] hover:text-[color:var(--brand-charcoal)] transition-colors">
                Hakkımızda
              </Link>
            </li>
            <li>
              <Link to="/vizyon-misyon" className="text-sm text-[color:hsl(var(--muted-foreground))] hover:text-[color:var(--brand-charcoal)] transition-colors">
                Vizyonumuz &amp; Misyonumuz
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-[var(--font-serif)] text-base mb-4 text-[color:var(--brand-charcoal)]">İletişim</h4>
          <ul className="space-y-3 text-sm text-[color:hsl(var(--muted-foreground))]">
            <li className="flex items-center gap-2">
              <Phone className="h-4 w-4 text-[color:var(--brand-gold)] shrink-0" /> 0312 277 12 72
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-[color:var(--brand-gold)] shrink-0" /> abdullahkarsli76@gmail.com
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 text-[color:var(--brand-gold)] shrink-0 mt-0.5" /> Yenikent, Sincan, Ankara
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--line)] py-5">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center">
          <p className="text-xs text-[color:hsl(var(--muted-foreground))]">
            © {new Date().getFullYear()} Abdullah Karslı Gayrimenkul Danışmanlığı. Tüm hakları saklıdır. — Tasarım &amp;
            Geliştirme: Zerqon Tech
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
